import React, { useState } from 'react';

import HomeRoundedIcon from '@material-ui/icons/HomeRounded';

import './HomeButton.css';

export default function HomeButton() {

  const [hover, setHover] = useState( false );

  return (

    <div className="menu-item">
        <a 
            href="http://dev-ze.rocks/projects/zen-balls" 
            title="Dev-Ze.rocks" 
            onMouseOver={() => setHover( true )} 
            onMouseLeave={() => setHover( false )}>
                <HomeRoundedIcon />
        </a>
        {hover ? <div className="homeButtonAlert">Leave to Dev-Ze.rocks</div> : null}
    </div>
  );
}

